<template>
  <div>
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12">
        <label>Discussion:</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="overflow: auto">
        <blockquote id="comments" class="blockquote" style="height: 572px; background-color: #1e1e2f; overflow-y: auto; overflow-x: hidden; padding: 5px 5px 15px;">
          <comment-list :comments="comments"
                        :employees="employees"
                        :employee_id="employee_id"></comment-list>
        </blockquote>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <blockquote class="blockquote" style="padding: 0;">
                  <textarea style="max-height: 100px; padding: 0; min-height: 10px; background-color: #1e1e2f;"
                            rows="2" cols="180"
                            class="form-control"
                            placeholder=" Write a message..."
                            v-model="text">
          </textarea>
        </blockquote>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-4 col-xl-8"></div>
      <div class="col-md-12 col-lg-8 col-xl-4" style="margin-top: -5px">
        <base-button class="clock-button" :disabled="ticket_id < 1" block simple type="info" @click="add()">
          Send
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
    import CommentList from "./CommentList";
    export default {
      name: "CommentsLayout",
      components: {CommentList},
      props: ['comments', "employees", "employee_id", "ticket_id"],
      data(){
        return{
          text:"",
          isMobile:false
        }
      },
      methods:{
        add(){
          const cTime = new Date();
          const comment = {
            comment_id : 0,
            ticket_id  : parseInt(this.ticket_id),
            employee_id: this.employee_id,
            date       : cTime.getFullYear() + '-' + (cTime.getMonth() + 1) + '-' + (cTime.getDate()) + ' ' + cTime.getHours() + ':' + cTime.getMinutes() + ':' + cTime.getSeconds(),
            text       : this.text,
          };
          this.$emit('add-comment', comment);
          this.text = "";
        },
      },
      created() {
        this.isMobile = (/Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent));

      }
    }
</script>

<style scoped>
  .blockquote{

  }
</style>
